import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Button,
  Grid,
  Divider,
} from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useLanguage } from "../contexts/LanguageContext";
import { formatMessage } from "../locales";

function Support() {
  const { messages } = useLanguage();

  const handleShare = async () => {
    const shareUrl = window.location.origin;
    const shareText =
      "Check out OpenCreed - an open platform for exploring and discussing religious texts!";

    if (navigator.share) {
      try {
        await navigator.share({
          title: "OpenCreed",
          text: shareText,
          url: shareUrl,
        });
      } catch (error) {
        if (error.name !== "AbortError") {
          await navigator.clipboard.writeText(`${shareText}\n${shareUrl}`);
          alert(formatMessage(messages, "common.copied"));
        }
      }
    } else {
      await navigator.clipboard.writeText(`${shareText}\n${shareUrl}`);
      alert(formatMessage(messages, "common.copied"));
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        align="center"
        color="primary"
      >
        {formatMessage(messages, "support.title")}
      </Typography>

      <Typography variant="h6" align="center" color="text.secondary" paragraph>
        {formatMessage(messages, "support.subtitle")}
      </Typography>

      <Grid container spacing={4} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 4, height: "100%" }}>
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <ShareIcon sx={{ fontSize: 48, color: "primary.main", mb: 2 }} />
              <Typography variant="h5" gutterBottom>
                {formatMessage(messages, "support.share.title")}
              </Typography>
              <Typography color="text.secondary" paragraph>
                {formatMessage(messages, "support.share.description")}
              </Typography>
              <Button
                variant="contained"
                size="large"
                onClick={handleShare}
                startIcon={<ShareIcon />}
              >
                {formatMessage(messages, "support.share.button")}
              </Button>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 4, height: "100%" }}>
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <FavoriteIcon sx={{ fontSize: 48, color: "error.main", mb: 2 }} />
              <Typography variant="h5" gutterBottom>
                {formatMessage(messages, "support.donate.title")}
              </Typography>
              <Typography color="text.secondary" paragraph>
                {formatMessage(messages, "support.donate.description")}
              </Typography>
              <Button
                variant="contained"
                color="error"
                size="large"
                disabled
                startIcon={<FavoriteIcon />}
              >
                {formatMessage(messages, "support.donate.button")}
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Divider sx={{ my: 6 }} />

      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          {formatMessage(messages, "support.why.title")}
        </Typography>
        <Typography color="text.secondary" paragraph>
          {formatMessage(messages, "support.why.description")}
        </Typography>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="primary">
              {formatMessage(messages, "support.why.maintain.title")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {formatMessage(messages, "support.why.maintain.description")}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="primary">
              {formatMessage(messages, "support.why.features.title")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {formatMessage(messages, "support.why.features.description")}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="primary">
              {formatMessage(messages, "support.why.content.title")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {formatMessage(messages, "support.why.content.description")}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default Support;
